import React, { Component } from "react";
import Table, { TableColumn } from "../Table";
import { ProcessorItem, shortenProcessorItemType } from "../../models/MailroomProcessorItem";
import { TableRowProps } from "../TableRow";
import TableCell from "../TableCell";
import { getAnyProperty } from "../../utils/Utils";

interface ProcessorItemTableProps {
    title: string;
    className?: string;
    shownItems: ProcessorItem[] | undefined;
    allItems: ProcessorItem[] | undefined;
    selectedItem?: ProcessorItem;
    virtualize: boolean;
    onItemClicked(item: ProcessorItem): void;
}

interface ProcessorItemTableState {
}

const columns: TableColumn[] = [
    {
        title: "Type",
        extraDetail: "Processor Item Number",
        propertyPath: "$type",
        flex: 1,
        enableSort: true
    },
    {
        title: "Sample A",
        propertyPath: "sampleA",
        extraDetail: "Sample data from processor item",
        flex: 2
    },
    {
        title: "Sample B",
        extraDetail: "Sample data from processor row",
        propertyPath: "sampleB",
        flex: 2
    },
    {
        title: "Status",
        propertyPath: "error",
        flex: 1,
        enableSort: true
    }
];

const misPropertyList: string[] = [
    "misItem.Email",
    "misItem.mail",
    "misItem.id",
    "misItem.Id",
    "misItem.ID",
    "misItem.Name",
    "misItem.UPN",
    "misItem.StaffNumber",
    "misItem.House",
    "misItem.SubjectName",
    "misItem.Year",
    "misItem.Key"
];

const sdsPropertyList: string[] = [
    "sdsRow.SectionName", // Section
    "sdsRow.Username", // Users
    "sdsRow.Email", // Parents
    "sdsRow.SISID", // Fallback
];


export default class ProcessorItemTable extends Component<ProcessorItemTableProps, ProcessorItemTableState>
{

    
    constructor(props: ProcessorItemTableProps) {
        super(props);

        this.state = {
        }
    }

    public componentDidMount() {
    }

    private processorItemsColumnRowProps = (row: ProcessorItem): TableRowProps => {

        const onClick = () => {
            this.props.onItemClicked(row)
        }

        return {
            onClick,
        };
    };

    private processorItemCellForColumn = (item: ProcessorItem, column: TableColumn, columnIndex: number): JSX.Element | undefined => {

        const value = item[column.propertyPath];
        if (column.propertyPath === "$type") {
            const shortType = shortenProcessorItemType(value);

            return (
                <TableCell flex={column.flex}>
                    <span title={shortType}>{shortType}</span>
                    <span className={"cdb-table__extra-detail"}>#{item["$id"]}</span>
                </TableCell>
            );
        }

        if (column.propertyPath === "sampleA") {
            let misProperty;
            if (item.user?.$ref !== undefined) {
                var user = this.props.allItems!.find(i => i.$id === item.user.$ref)
                misProperty = getAnyProperty(user, sdsPropertyList)
            }
            else {
                misProperty = getAnyProperty(item, misPropertyList);
            }

            if (misProperty) {
                return (
                    <TableCell flex={column.flex}>
                        <span title={misProperty.value}>{misProperty.value}</span>
                        <span className="cdb-table__extra-detail">{misProperty.propertyName}</span>
                    </TableCell>
                );
            }
        }

        if (column.propertyPath === "sampleB") {

            let sdsProperty;
            if (item.section?.$ref !== undefined) {
                var section = this.props.allItems!.find(i => i.$id === item.section.$ref)
                sdsProperty = getAnyProperty(section, sdsPropertyList)
            }
            else {
                sdsProperty = getAnyProperty(item, sdsPropertyList);
            }

            if (sdsProperty) {
                return (
                    <TableCell flex={column.flex}>
                        <span title={sdsProperty.value}>{sdsProperty.value}</span>
                        <span className="cdb-table__extra-detail">{sdsProperty.propertyName}</span>
                    </TableCell>
                );
            }
        }

        if (column.propertyPath === "error") {
            const error = item[column.propertyPath];

            const pillText = error ? `${item.errors.length} Error(s)` : "Success";
            const pillColour = error ? "red" : "green";
            const pillModifierClass = error ? "pill--tiny" : "";

            return (
                <TableCell flex={column.flex}>
                    <span className={`pill pill--${pillColour} ${pillModifierClass}`}>{pillText}</span>
                    <span className="cdb-table__extra-detail cdb-table__extra-detail--ellipsis">{item.errors[0]?.message}</span>
                </TableCell>
            );
        }

    }

    public render() {
        return (
            <Table
                className={this.props.className}
                title={this.props.title}
                items={this.props.shownItems == undefined ? [] : this.props.shownItems}
                loading={this.props.shownItems == undefined}
                emptyMessage="No processor items"
                selectedItem={this.props.selectedItem}
                columns={columns}
                rowPropsForItem={this.processorItemsColumnRowProps}
                cellForColumn={this.processorItemCellForColumn}
                enableSort={true}
                virtualize={this.props.virtualize}>
                {this.props.children}
            </Table>
        );
    }
}